import { motion } from "framer-motion";
import { MessageCircle, CalendarCheck } from "lucide-react";
import { BRAND } from "@/data/content";
import { openLeadModal } from "@/components/LeadModal";

const FloatingButtons = () => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 2.2, duration: 0.7 }}
    className="fixed bottom-5 right-5 z-[60] flex flex-col gap-3 items-end"
  >
    <button
      data-testid="floating-book-call-btn"
      onClick={() => openLeadModal()}
      className="btn-gradient text-white text-sm font-semibold px-5 py-3 rounded-full inline-flex items-center gap-2"
    >
      <CalendarCheck className="w-4 h-4" /> <span className="hidden sm:inline">Book a Free Strategy Call</span><span className="sm:hidden">Book Call</span>
    </button>
    <a
      href={BRAND.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
      className="w-12 h-12 rounded-full glass border-indigo-400/40 flex items-center justify-center text-white hover:border-indigo-300 transition-colors duration-300 shadow-[0_0_24px_rgba(99,102,241,0.35)]"
    >
      <MessageCircle className="w-5 h-5" />
    </a>
  </motion.div>
);

export default FloatingButtons;
